import { render } from "./icon-prepared.svg?vue&type=template&id=0afaf745&scoped=true&component"
const script = {  }

import "./icon-prepared.svg?vue&type=style&index=0&id=0afaf745&scoped=true&lang=css&component"

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afaf745"]])

export default __exports__